.children {
  padding: 8px 0;
}

.code {
  padding: 8px 0;
  display: block;
}

.contact {
  padding: 16px 0;
}
